'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { ThemeProvider } from 'structure/chat/components/theme-provider';
import { Connector, useConnection } from 'wagmi';
import dynamic from 'next/dynamic';

const ChatPage = dynamic(() => import('structure/chat/components/ChatPage'), {
  ssr: false,
});

export default function Chat() {
  const [mounted, setMounted] = useState(false);
  const router = useRouter();

  useEffect(() => setMounted(true), []);

  const { connector: activeConnector } = useConnection();

  useEffect(() => {
    const handleConnectorUpdate = ({ account }: Connector) => {
      if (account) {
        router.push('/chat');
      }
    };

    if (activeConnector) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      activeConnector.emitter?.on('change', handleConnectorUpdate as any);
    }

    return () => {
      if (activeConnector) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        activeConnector.emitter?.off('change', handleConnectorUpdate as any);
      }
    };
  }, [activeConnector, router]);

  return (
    <BaseLayout
      classNames={{ content: 'aichat pt-4 lg:pt-0' }}
      showFooter={false}
    >
      <ThemeProvider
        attribute='class'
        defaultTheme='dark'
        enableSystem
        disableTransitionOnChange
      >
        {mounted ? <ChatPage /> : null}
      </ThemeProvider>
    </BaseLayout>
  );
}
